import { blrfOperations } from 'app/state/ducks/blrf';

const { clear } = blrfOperations;

const get = ( key, id ) => async ( dispatch ) => {

    return await dispatch ( blrfOperations.get( {
        endpoint: 'coin/currency',
        key,
        id
    }) );
    
};

const update = ( key, id, data ) => async ( dispatch ) => {

    return await dispatch ( blrfOperations.update( {
        endpoint: `coin/currency/${id}`,
        key,
        data
    }) );

};

const create = ( key, data ) => async ( dispatch ) => {

    return await dispatch ( blrfOperations.create( {
        endpoint: 'coin/currency',
        key,
        data
    }) );

};

const search = ( key, data ) => ( dispatch ) => {

    return dispatch ( blrfOperations.search( {
        endpoint: 'coin/currency/search',
        key, 
        data
    }) );

};

const remove = ( key, id ) => async ( dispatch ) => {

    return await dispatch ( blrfOperations.remove( {
        endpoint: `coin/currency/${id}`,
        key
    }) );

};

export {
    get, 
    update, 
    create,
    search,
    remove,
    clear
};
